module.exports = __webpack_public_path__ + "media/curiosity.cc8b9896.mp4";